import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../componets/Sidebar';

const DashboardLayout = () => {
  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)',
    }}>
      <Sidebar />
      <main style={{
        marginLeft: '230px',
        flex: 1,
        width: 'calc(100% - 230px)',
        minHeight: '100vh',
        padding: '2rem',
        transition: 'margin-left 0.3s ease',
      }}
      className="main-content"
      >
        <Outlet />
      </main>

      <style>{`
        @media (max-width: 768px) {
          .main-content {
            margin-left: 0 !important;
            width: 100% !important;
            padding: 5rem 1rem 2rem 1rem !important;
          }
        }

        @media (max-width: 480px) {
          .main-content {
            padding: 5rem 0.75rem 1.5rem 0.75rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default DashboardLayout;